import { Fragment } from 'react';

import { PromotionType, rage, useObservable } from '~/rage';

import { AdminInfo } from '../AdminInfo';

import { Text } from '~/components/ui/Text';
import {
	StyledBonusContainer,
	StyledBonusDivider,
	StyledContainer,
	StyledDivider,
	StyledLogo,
	StyledOnlineContainer,
	StyledOnlineIcon,
	StyledServerContainer,
} from './ServerInfo.styled';

const ServerInfo: React.FC = () => {
	const promotion = useObservable(rage.game.getActivePromotion());
	const onlinePlayers = useObservable(rage.game.getOnlinePlayers());

	return (
		<StyledContainer>
			<StyledServerContainer>
				{promotion === PromotionType.DonateX2 ? (
					<StyledBonusContainer>
						<StyledLogo />
						<StyledBonusDivider />
						<Text>X2</Text>
					</StyledBonusContainer>
				) : (
					<Fragment>
						<StyledLogo />
						<StyledDivider />
					</Fragment>
				)}
				<StyledOnlineContainer>
					<StyledOnlineIcon />
					<Text>{onlinePlayers}</Text>
				</StyledOnlineContainer>
			</StyledServerContainer>
			<AdminInfo />
		</StyledContainer>
	);
};

export { ServerInfo };
